<style scoped lang="scss">
.wrapper {
  margin: 0 auto 10px;
}

.header {
  display: flex;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #999999;

  .back {
    margin-right: 20px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -3px;
    }

    span {
      padding-left: 2px;

      &:hover {
        color: $color-theme;
      }
    }
  }
}

.main {
  min-height: calc(100vh - 170px);
  background: #fff;
  border-radius: 6px;

  .main-head {
    background-color: #f5f5f5;
    padding: 10px 0 20px;
    display: flex;
    justify-content: space-between;

    .head-left {
      .el-select {
        width: 130px;
      }
    }

    .head-right {}
  }

  .main-body {
    .table-wrap {
      .delete-btn {
        color: #ff0000;
      }

      .pagination {
        float: right;
        margin: 10px 0;
        padding-top: 10px;

        .el-pagination {
          padding-right: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.task-look {
  .export-form {
    text-align: center;

    .el-dialog__body {
      padding: 20px 20px 0;

      h3 {
        text-align: center;
        font-size: $font-size-large;
        color: #333;
        margin: 25px 0;
      }
    }

    .el-dialog__footer {
      text-align: center !important;
    }
  }

  .add-form {
    .el-form-item {
      display: flex;
      justify-content: center;
      margin-bottom: 12px;

      .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    .el-dialog__footer {
      text-align: center;
    }
  }

  .search {
    vertical-align: top;
    display: inline-block;
    margin-left: 20px;

    .el-button {
      padding: 0;
    }

    .el-input {
      display: inline-block;
      float: left;
      width: 170px;

      .el-input__inner {
        display: inline-block;
        border: 1px solid $color-border;
        box-sizing: border-box;
        border-radius: 20px 0 0 20px;

        &::-webkit-input-placeholder {
          color: #ccc;
        }

        &:-ms-input-placeholder {
          color: #ccc;
        }

        &::placeholder {
          color: #ccc;
        }

        &:hover {
          border-color: $color-border;
        }
      }
    }

    >.button {
      float: left;
      display: inline-block;
      height: 32px;
      background: $color-theme;
      border: none;
      width: 36px;
      padding-left: 2px;
      border-radius: 0 20px 20px 0;
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 0.72;
      }
    }
  }
}
</style>

<template>
  <div class="wrapper task-look">
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="8" />
        <span>返回</span>
      </div>
    </header>
    <div class="main">
      <div class="main-head">
        <div class="head-left">
          <el-form :inline="true">
            <el-select v-model="classId" placeholder="全部班级" size="small">
              <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id">
              </el-option>
            </el-select>
            <div class="search">
              <el-input v-model="field" size="small" clearable placeholder="请输入学生姓名"
                @keyup.enter.native="currentPage = 1; _examTaskStuList()"></el-input>
              <el-button class="button" @click="currentPage = 1; _examTaskStuList()">
                <img src="~images/search.png" width="18" height="18" />
              </el-button>
            </div>
          </el-form>
        </div>
        <div class="head-right">
          <el-button type="primary" size="medium" plain @click="addDialog">增加学生</el-button>
          <el-button type="primary" size="medium" @click="exportDialog">导出考务</el-button>
        </div>
      </div>
      <div class="main-body">
        <div class="table-wrap" style="padding: 10px;background: #fff;">
          <el-table :data="tableData" v-loading="loading" size="medium">
            <el-table-column prop="gradeName" align="center" label="年级">
            </el-table-column>
            <el-table-column prop="className" align="center" label="班级">
            </el-table-column>
            <el-table-column prop="stuNo" align="center" label="学号">
            </el-table-column>
            <el-table-column prop="stuName" align="center" label="学生姓名">
            </el-table-column>
            <el-table-column prop="examCode" align="center" label="考试号">
            </el-table-column>
            <el-table-column prop="examRoom" align="center" label="考场">
            </el-table-column>
            <el-table-column prop="examNo" align="center" label="座次">
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="140">
              <template slot-scope="scope">
                <el-button class="link-btn" @click="editDialog(scope.$index)" type="text">编辑</el-button>
                <el-button type="text" class="delete-btn" @click="_delConfirm(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="clearfix">
            <div class="pagination">
              <zj-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 50]" :page="{ total: count, current: currentPage }"></zj-pagination>
            </div>
          </div>
        </div>
        <!--table wrap end-->
      </div>
    </div>

    <!--导出考务对话框-->
    <yue-dialog :visible.sync="exportVisible" title="导出考务" class="export-form" @close="resetPaste">
      <h3>请选择需要导出的内容（可多选）</h3>
      <el-form :model="exportForm" :inline="true">
        <el-form-item>
          <el-checkbox v-model="deskPaste">桌贴</el-checkbox>
          <el-checkbox v-model="classPaste">班贴</el-checkbox>
          <el-checkbox v-model="doorPaste">门贴</el-checkbox>
          <el-checkbox v-model="qrCode">二维码</el-checkbox>
          <el-checkbox v-model="examNum" disabled>准考证号</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportTask">导出</el-button>
      </span>
    </yue-dialog>

    <!--增加学生对话框-->
    <yue-dialog :visible.sync="addVisible" title="增加学生" class="add-form" width="500px">
      <el-form :model="addForm" label-width="80px" label-position="right" ref="addStudentForm" :rules="rules"
        size="small">
        <el-form-item label="班级:" prop="classId">
          <el-select v-model="addForm.classId" placeholder="选择班级" clearable>
            <el-option v-for="item in classList2" :key="item.id" :label="item.className" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名:" prop="stuId">
          <el-select v-model="addForm.stuId" placeholder="选择学生" clearable filterable>
            <el-option v-for="item in studentList" :key="item.id" :label="item.studName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试号:" prop="examCode">
          <el-input v-model="addForm.examCode" placeholder="请输入考试号"></el-input>
        </el-form-item>
        <el-form-item label="考场:" prop="examRoom">
          <el-input v-model="addForm.examRoom" placeholder="请输入两位数考场号"></el-input>
        </el-form-item>
        <el-form-item label="座次:" prop="examNo">
          <el-input v-model="addForm.examNo" placeholder="请输入座次"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('addStudentForm', addStudentSubmit)"
          :loading="submitLoading">保存</el-button>
      </span>
    </yue-dialog>

    <!--编辑学生对话框-->
    <yue-dialog :visible.sync="editVisible" title="编辑学生" class="add-form" width="500px">
      <el-form :model="editForm" label-width="80px" label-position="right" ref="editStudentForm" :rules="rules"
        size="small">
        <el-form-item label="班级:" prop="classId">
          <el-select v-model="editForm.classId" placeholder="选择班级" clearable disabled>
            <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名:" prop="stuName">
          <el-select v-model="editForm.stuName" placeholder="选择学生" clearable filterable disabled>
            <el-option v-for="item in studentList" :key="item.id" :label="item.studName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试号:" prop="examCode">
          <el-input v-model="editForm.examCode" placeholder="请输入考试号"></el-input>
        </el-form-item>
        <el-form-item label="考场:" prop="examRoom">
          <el-input v-model="editForm.examRoom" placeholder="请输入两位数考场号"></el-input>
        </el-form-item>
        <el-form-item label="座次:" prop="examNo">
          <el-input v-model="editForm.examNo" placeholder="请输入座次"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="submitForm('editStudentForm', editStudentSubmit)"
          :loading="submitLoading">保 存</el-button>
      </span>
    </yue-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/utils/util.js'
import { getGradeClassList, getStudentList } from '@/api/api'
import { examTaskStuList, examTaskStuDel, examTaskStuAdd, examTaskStuUpdate } from '@/api/tool'
import { domain } from '@/config'
import ZjPagination from '../../zujuan/components/ZjPagination.vue'
export default {
  components: { ZjPagination },
  data () {
    return {
      schoolId: '',
      tableData: [],
      domain: domain,
      gradeId: '',
      managementId: '',
      classId: '',
      classList: [],
      classList2: [],
      studentList: [],
      field: '',

      //分页字段
      currentPage: 1,
      pageSize: 10,
      pageNo: 1,
      count: 0,

      loading: false,
      submitLoading: false,

      classPaste: true,
      deskPaste: true,
      doorPaste: true,
      qrCode: false,
      examNum: false,//准考证号

      //导出考务对话框
      exportVisible: false,
      exportForm: {},

      //增加学生对话框
      addVisible: false,
      addForm: {},
      rules: {
        stuId: [
          { required: true, message: '请选择学生', trigger: 'blur' }
        ],
        classId: [
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
        examCode: [
          { required: true, message: '请填写考试号', trigger: 'blur' },
        ],
        examRoom: [
          { required: true, message: '请填写考场号', trigger: 'blur' },
          { pattern: /^\d{2}$/, message: '考场号只能为2位数数字', trigger: 'blur' }
        ],
        examNo: [
          { required: true, message: '请填写座次号', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '座次号只能为数字', trigger: 'blur' }
        ],
      },

      //编辑学生对话框
      editVisible: false,
      editForm: {},
    }
  },
  mounted () {
    this.schoolId = this.userInfo.schoolId
    this.gradeId = this.$route.params.gradeId
    this.managementId = this.$route.params.id
    this._getClassList()
    this._examTaskStuList()
  },

  methods: {
    //学生列表
    async _examTaskStuList () {
      this.loading = true
      this.tableData = []
      this.count = 0
      let resp = await examTaskStuList({
        schoolId: this.schoolId,
        clazzId: this.classId,
        managementId: this.managementId,
        keyword: this.field,
        pageSize: this.pageSize,
        currentPage: this.currentPage
      })
      this.loading = false
      if (resp.body) {
        this.tableData = resp.body.items
        this.count = resp.body.totalSize
      }
    },

    // 获取班级
    async _getClassList () {
      let params = {
        gradeId: this.gradeId
      }
      let resp = await getGradeClassList(params)
      resp.body.unshift({
        id: '',
        className: '全部班级'
      })
      this.classList = resp.body
      this.classList2 = resp.body
    },

    // 获取学生
    async _getStudentList (classId) {
      let params = {
        schoolId: this.userInfo.schoolId,
        classId: classId,
        currentPage: 1,
        pageSize: 999,
      }
      let resp = await getStudentList(params)

      this.studentList = resp.body.items
    },

    setStudent (stuId) {
      let arr = this.studentList.filter(item => {
        return item.id == stuId
      })
      if (arr.length > 0) {
        let stu = arr[0]
        this.addForm.className = stu.className
        this.addForm.gradeId = stu.gradeId
        this.addForm.gradeName = stu.gradeName
        this.addForm.manageId = this.managementId
        this.addForm.stuCode = stu.studCode
        this.addForm.stuName = stu.studName
        this.addForm.stuNo = stu.studNo
      }
    },

    submitForm (formName, callback, params) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true
          callback(params)
        } else {
          return false
        }
      })
    },

    //增加考生
    addStudentSubmit () {
      MtaH5.clickStat("tooltaskaddstudent")
      let data = this.addForm
      this._examTaskStuAdd(data)
    },

    async _examTaskStuAdd (data) {
      let resp = await examTaskStuAdd(data)
      if (resp.body) {
        this.addVisible = false
        this.submitLoading = false
        this._examTaskStuList()
        this.$message({
          type: 'success',
          message: '新增成功!'
        })
      } else {
        this.$message.error(resp.message)
        this.submitLoading = false
      }
    },

    //编辑更新考生
    editStudentSubmit () {
      let data = this.editForm
      this._examTaskStuUpdate(data)
    },

    async _examTaskStuUpdate (data) {
      let resp = await examTaskStuUpdate(data)
      if (resp.body) {
        this.editVisible = false
        this.submitLoading = false
        this._examTaskStuList()
        this.$message({
          type: 'success',
          message: '更新成功!'
        })
      } else {
        this.$message.error(resp.message)
        this.submitLoading = false
      }
    },

    _delConfirm (index) {
      MtaH5.clickStat("tooltaskremovestudent")
      let stuName = this.tableData[index].stuName
      this.$confirm('是否将 ' + stuName + ' 从本次考务中删除？', '提示', {
        type: 'warning'
      }).then(() => {
        this._examTaskStuDel(index)
      })
    },
    //删除考生
    async _examTaskStuDel (index) {
      let id = this.tableData[index].id
      let response = await examTaskStuDel(id)
      console.log(response)
      if (response.body) {
        this.tableData.splice(index, 1)
        this._examTaskStuList()
        this.$message.success('删除成功!');
      } else {
        this.$message.error(response.message || '删除失败!');
      }
    },

    addDialog () {
      this.addVisible = true
      this.$nextTick(() => {
        // this.$refs.addStudentForm.resetFields()
      })
    },

    editDialog (index) {
      this.editForm = JSON.parse(JSON.stringify(this.tableData[index]))
      this.editVisible = true
    },

    resetEditForm () {
      this.editForm = {}
    },

    exportDialog () {
      this.exportVisible = true
    },

    exportTask () {
      this.submitLoading = true
      let url = this.domain + `/marking-platform/exam-managements/${this.managementId}/docs?clazz=${this.classPaste ? 1 : 0}&door=${this.doorPaste ? 1 : 0}&desk=${this.deskPaste ? 1 : 0}&qr=${this.qrCode ? 1 : 0}&token=${YJ_SCHOOL_STORAGE.getItem('token')}`
      window.open(url)
      this.submitLoading = false
      this.exportVisible = false
      this.resetPaste()
    },

    resetPaste () {
      this.classPaste = true
      this.doorPaste = true
      this.deskPaste = true
      this.qrCode = true
    },

    //分页处理
    handleSizeChange (val) {
      this.pageSize = val
      this._examTaskStuList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this._examTaskStuList()
    },
  },

  watch: {
    classId (val) {
      this.currentPage = 1
      this._examTaskStuList()
    },
    'addForm.classId' (val) {
      this.studentList = []
      this.$set(this.addForm, 'stuId')
      this._getStudentList(val)
    },
    'addForm.stuId' (val) {
      this.setStudent(val)
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },
}
</script>
